import customForm from './components/form.vue';

export default customForm;
